import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectionRow from './SelectionRow';
import { marketDisplayName } from '../utils';
import { OUTRIGHT_ACCENT } from '../theme';

function MarketGroup({ event, market, defaultExpanded = false }) {
  const { t } = useTranslation('translations', { useSuspense: false });
  const [expanded, setExpanded] = useState(defaultExpanded);

  if (!market?.outcomes?.length) return null;

  // Sort outcomes ascending by odds (favorites first).
  const sorted = [...market.outcomes].sort((a, b) => {
    const ao = typeof a.odds === 'number' ? a.odds : Infinity;
    const bo = typeof b.odds === 'number' ? b.odds : Infinity;
    return ao - bo;
  });
  const total = sorted.length;
  const visible = expanded ? sorted : sorted.slice(0, 3);
  const hasMore = total > 3;

  const toggle = () => setExpanded((v) => !v);

  return (
    <div className="matchCard bg-will-no-live mb-2" style={{ flexWrap: 'nowrap', display: 'block' }}>
      <button
        type="button"
        onClick={toggle}
        className="btn w-100 d-flex align-items-center gap-2 py-2 px-3"
        style={{
          background: 'transparent',
          border: 'none',
          color: 'var(--bs-body-color)',
          textAlign: 'left',
          borderBottom: expanded ? '1px solid rgba(255,255,255,0.15)' : 'none'
        }}>
        <span className="fw-bold" style={{ fontSize: '0.95rem' }}>
          {marketDisplayName(market, t)}
        </span>
        <span
          className="ms-auto"
          style={{
            transform: expanded ? 'rotate(180deg)' : 'none',
            transition: 'transform 180ms ease'
          }}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path
              d="M2 3l3 3 3-3"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      <div
        className="py-2"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          columnGap: '0.5rem',
          rowGap: '0.5rem',
          paddingLeft: 0,
          paddingRight: 0
        }}>
        {visible.map((outcome) => (
          <SelectionRow
            key={outcome.id}
            event={event}
            market={market}
            outcome={outcome}
            betBox="bg-button-will-no-live"
          />
        ))}
      </div>

      {!expanded && hasMore && (
        <button
          type="button"
          onClick={toggle}
          className="btn w-100 py-2"
          style={{
            background: 'transparent',
            border: 'none',
            borderTop: '1px solid rgba(255,255,255,0.15)',
            color: OUTRIGHT_ACCENT,
            fontWeight: 700,
            fontSize: '0.8rem'
          }}>
          {t('outrights.showAll', { count: total })}
        </button>
      )}
    </div>
  );
}

export default MarketGroup;
